import { render, staticRenderFns } from "./generator.object.type.label.vue?vue&type=template&id=e16a9e2c&"
import script from "./generator.object.type.label.vue?vue&type=script&lang=ts&"
export * from "./generator.object.type.label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports